import { render } from "./SetupDialog.vue?vue&type=template&id=3745630a&scoped=true"
import script from "./SetupDialog.vue?vue&type=script&lang=js"
export * from "./SetupDialog.vue?vue&type=script&lang=js"

import "./SetupDialog.vue?vue&type=style&index=0&id=3745630a&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3745630a"]])

export default __exports__